import FnrErrorBoundary from "UI/FnrErrorBoundary";
import Portal from "Utilities/PortalMaker";
import { usePortalElement } from "Utilities/PortalMaker/usePortalElement";

import NavBar from "./NavBar";

const NavBarPortal = () => {
  const portalElement = usePortalElement("#nav_react_holder");

  if (!portalElement) return null; // non-React area hasn't loaded yet

  return (
    <Portal to={portalElement}>
      <FnrErrorBoundary boundaryName="NavBar">
        <NavBar />
      </FnrErrorBoundary>
    </Portal>
  );
};

export default NavBarPortal;
